module.exports = __webpack_public_path__ + "img/8.5ecaa5f2.jpg";